import { memo } from "react";
import { CommentingCardChrome } from "@sudowrite/shared-chat";
import type { CommentingData } from "src/stores/persistentChatStore";
import { SYSTEM_FEEDBACK_TYPE_CATEGORY_MAP } from "src/shared/feedbackCategories";
import { useCommentingDisplayProgress } from "./useCommentingDisplayProgress";
import { commentingCardWebIcons } from "./planCardWebIcons";

type Props = {
  commenting: CommentingData;
  mode: "floating" | "inline";
  onCancel?: () => void;
};

export const CommentingCard = memo(({ commenting, mode, onCancel }: Props) => {
  const displayProgress = useCommentingDisplayProgress(commenting);

  return (
    <CommentingCardChrome
      commenting={commenting}
      mode={mode}
      displayProgress={displayProgress}
      feedbackCategoryByName={SYSTEM_FEEDBACK_TYPE_CATEGORY_MAP}
      icons={commentingCardWebIcons}
      onCancel={onCancel}
    />
  );
});
